<template>
    <Sections>
        <AppSubheader title="Live" :dark="true"></AppSubheader>
        <SectionStreamJumbo
            v-if="activeStream"
            :stream="activeStream"
        ></SectionStreamJumbo>
        <SectionJumbo
            v-else-if="isPremiumMember"
            padding="py-24"
            :image="$config.public.uploads + 'images-general/learn-guitar-and-ukuele-online-with-andy.jpg'"
            imageAlt="Andy playing his signature acoustic guitar in his studio"
            imageOpacity="opacity-30"
            heading="Live"
            headingColor="text-white"
            content="<p>Join regular live streams with your AAA Membership</p>"
            contentColor="text-white"
            :textCentered="false"
        ></SectionJumbo>
        <SectionJumbo
            v-else
            padding="py-24"
            :image="$config.public.uploads + 'images-general/learn-guitar-and-ukuele-online-with-andy.jpg'"
            imageAlt="Andy playing his signature acoustic guitar in his studio"
            imageOpacity="opacity-30"
            heading="Live"
            headingColor="text-white"
            content="<p>Join regular live streams with AAA Membership</p>"
            contentColor="text-white"
            :buttonText="currentUser?.eligible_for_aaa_free_trial ? 'Accept Free Trial' : 'Renew Membership'"
            :buttonRoute="useContextConversion().routeMembership('live-locked-embed')"
            :textCentered="false"
        ></SectionJumbo>
        <SectionText
            heading="How it works"
            headingComponent="h2"
            content="<ArticleLiveDescription />"
        ></SectionText>
        <SectionStreams
            padding="pb-8 sm:pb-8 pt-0"
            heading="Upcoming Streams"
            :streams="upcomingStreams"
        ></SectionStreams>
        <SectionLiveReplays
            color="bg-zinc-100"
            :lessons="liveReplays"
        ></SectionLiveReplays>
        <LoadingSpinner
            v-if="streams === null"
        ></LoadingSpinner>
    </Sections>
</template>

<script setup>
const {currentUser} = storeToRefs(useStoreAuth());
const isPremiumMember = computed(() => {
    return !!currentUser.value?.has_aaa_membership;
});

const {streams, activeStream, upcomingStreams} = storeToRefs(useStoreStreams());
const {getStreams} = useStoreStreams();

const {lessons: liveReplays} = storeToRefs(useStoreLiveReplays());
const {getLessons: getLiveReplays} = useStoreLiveReplays();

await useLazyAsyncData('load', () => getStreams().then(() => true));

onMounted(() => {
    getStreams();
    getLiveReplays();
});

useSeo().buildHead({
    title: 'Live | Andy Guitar',
    description: 'Join Andy and his team for a weekly live stream.',
    index: true,
});
</script>
